import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../constants/colors';

const CartButtonContainer = styled.button`
  position: relative;
  background: none;
  color: ${COLORS.PRIMARY};
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -6px;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0 3px;
  border: 1.5px solid white;
`;

export const CartButton: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <CartButtonContainer
      onClick={() => navigate('/cart')}
      aria-label={t('cart.button.ariaLabel', { count: itemCount, defaultValue: `Shopping cart with ${itemCount} items` })}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
      {itemCount > 0 && <Badge>{itemCount}</Badge>}
    </CartButtonContainer>
  );
};